export const enumValues = obj => Object.keys(obj).map(key => obj[key]);